import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Avatar, Button, Divider, Form, Input, message, Progress, Table, Upload, Alert } from "antd";
import axios from 'axios';
import { DeleteFilled, InboxOutlined } from '@ant-design/icons';
import Moment from "moment";
import { useMutation } from 'react-query';
import { UpdateRelease } from "../../../../../api/release";
import { GetApp } from "../../../../../api/apps";  // Импортируем API функцию
import Config from "../../../../../config";
import Store from "../../../../../library/store";

export const ReleaseCreateController = (props) => {
    const params = useParams();
    const nav = useNavigate();
    const [appData, setAppData] = useState(null);  // Добавляем состояние для данных о приложении
    const [release, setRelease] = useState({});
    const [form] = Form.useForm();

    useEffect(() => {
        GetApp(params.developer_id, params.app_id)
            .then(data => {
                setAppData(data.app);
            })
            .catch(error => {
                console.error("Failed to get app data", error);
            });
    }, [params.developer_id, params.app_id]);

    const UpdateReleaseMutations = useMutation(
        (data) => UpdateRelease(params.developer_id, params.app_id, release.id, data),
        {
            onSuccess: (data) => {
                message.success(`Выпуск успешно создан. Вы можете отправить его на модерацию`);
                nav(`/console/${params.developer_id}/app/${params.app_id}/release`);
            },
            onError: (e) => {
                console.error(`[UpdateReleaseMutations] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    );

    useEffect(() => {
        if (release.version_name) {
            form.setFieldsValue({
                release_name: `${release.version_code} (${release.version_name})`
            })
        }
    }, [release]);

    const onFormFinish = (data) => {
        if (!release || !release.id) {
            message.error(`Необходимо загрузить APK-файл`);
        } else {
            UpdateReleaseMutations.mutate({...data});
        }

    }

    return (
        <div className={`dev__layout release--layout`}>
             <h1>{appData ? `${appData.title}: ` : ""} Выпуск нового релиза</h1>  
                       <div className="dev__layout--content" style={{marginTop: 20}}>
                <ReleaseUploader
                    developer_id={params.developer_id}
                    app_id={params.app_id}
                    app_type={appData ? appData.type : null}  
                    appData={appData}  
                    onSelectRelease={setRelease}
                />
                <Divider>Примечание к выпуску</Divider>
                <Form
                    name={`release_description`}
                    layout={`vertical`}
                    form={form}
                    onFinish={onFormFinish}
                    initialValues={{
                        release_name: release?.version_name ? `${release.version_code} (${release.version_name})` : ''
                    }}
                >
                    <Form.Item
                        label={`Название выпуска`}
                        name={`release_name`}
                        rules={[{required: true, message: `Укажите название выпуска`}]}
                        extra={`Например, это может быть номер обновления`}
                    >
                        <Input maxLength={120}/>
                    </Form.Item>

                    <Form.Item
                        label={`Примечание к выпуску`}
                        name={`release_description`}
                        extra={`Расскажите пользователям, что именно обновили в этом релизе`}
                        rules={[{required: true, message: `Укажите примечание к выпуску`}]}
                    >
                        <Input.TextArea maxLength={5000}/>
                    </Form.Item>
                    <Button type={`primary`} htmlType={`submit`} loading={UpdateReleaseMutations.isLoading}>Создать выпуск</Button>
                </Form>
            </div>
        </div>
    );
}

const ReleaseUploader = (props) => {
    const {developer_id, app_id, app_type, appData} = props;
    const [startUploading, setStartUploading] = useState(false);
    const [isFinished, setIsFinished] = useState(false);
    const [progress, setProgress] = useState(0);
    const [release, setRelease] = useState([]);

    const uploadProps = {
        accept: app_type === 'linux' ? '.rpm' : '.apk',
        name: app_type === 'linux' ? 'rpm_file' : 'apk_file',
       // accept: ".apk",
       //name: 'apk_file',
        showUploadList: false,
        beforeUpload: async (file) => {
            await setStartUploading(true);
            await setProgress(0);
            let formData = new FormData();
            formData.append("file", file, file.name);
            axios.post(`${Config.API}console/${developer_id}/app/${app_id}/release/${app_type === 'linux' ? 'upload_rpm' : 'upload'}`, formData, {
            //axios.post(`${Config.API}console/${developer_id}/app/${app_id}/release/upload`, formData, {
                withCredentials: true,
                onUploadProgress: progressEvent => {
                    let progress = ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
                    setProgress(progress);
                }
            }).then(res => {
                setIsFinished(true);
                let releases = [];
                if (res?.data?.release) {
                    releases.push(res?.data?.release || {})
                }
                setRelease(releases);
                props.onSelectRelease(res?.data?.release || {});
            }).catch(e => {
                setProgress(0);
                setStartUploading(false);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            });
            return false;
        }
    };


    /*
    const columns = [
        {
            title: '',
            key: 'icon',
            render: r => {
                const dateIndex = Moment(r.createdAt).utc().format("YYYY-MM-DD")
                return (<Avatar size={40} shape={`square`}
                                src={`${Config.MEDIA.APK_IMAGE}/${dateIndex}/${r.release_prefix}/${r.store_icon}`}/>)
            }
        },
        {
            title: "Тип файла",
            key: "file_type",
            render: r => `APK`
        },
        {
            title: "Версия",
            key: "version",
            render: r => {
                return (`${r.version_code} (${r.version_name})`);
            }
        },
        {
            title: 'Версия API',
            key: 'api',
            align: 'center',
            render: r => {
                return `${r.sdk_min}+`
            }
        },
        {
            title: 'Текущая SDK',
            key: 'sdk',
            align: 'center',
            render: r => {
                return `${r.sdk_target}`
            }
        },
        {
            title: 'Количество разрешений',
            key: 'permissions',
            align: 'center',
            render: r => {
                return `${r.permissions.length}`
            }
        },
        {
            title: '',
            key: 'actions',
            align: 'center',
            render: () => {
                return (
                    <Button
                        icon={<DeleteFilled/>}
                        type={`danger`}
                        shape={`circle`}
                        onClick={() => {
                            setIsFinished(false);
                            setRelease([]);
                            setStartUploading(false);
                        }}
                    />
                )
            }
        }
    ];

    */

    let columns = [
        {
            title: '',
            key: 'icon',
            render: r => {
                const dateIndex = Moment(r.createdAt).utc().format("YYYY-MM-DD")
                return (<Avatar size={40} shape={`square`}
                                src={`${Config.MEDIA.APK_IMAGE}/${dateIndex}/${r.release_prefix}/${r.store_icon}`}/>)
            }
        }];





        if (app_type && app_type === 'linux') {
            columns.push(
                // Специфические поля для Linux
                {
                    title: "Название пакета",
                    key: "package_name",
                    render: r => r.package_name
                },{
                    title: "Тип файла",
                    key: "file_type",
                    render: r => `RPM`
                },
                {
                    title: "Версия",
                    key: "version",
                    render: r => {
                        return (`${r.version_code} (${r.version_name})`);
                    }
                },
                {
                    title: "ОС",
                    key: "os",
                    render: r => r.os
                },
                {
                    title: "Архитектура",
                    key: "architecture",
                    render: r => r.architecture
                } 
            );
        } else {
            columns.push(
                {
                    title: "Название пакета",
                    key: "package_name",
                    render: r => r.package_name
                },{
                    title: "Тип файла",
                    key: "file_type",
                    render: r => `APK`
                },
                {
                    title: "Версия",
                    key: "version",
                    render: r => {
                        return (`${r.version_code} (${r.version_name})`);
                    }
                },
                {
                    title: 'Версия API',
                    key: 'api',
                    align: 'center',
                    render: r => {
                        return `${r.sdk_min}+`
                    }
                },
                {
                    title: 'Текущая SDK',
                    key: 'sdk',
                    align: 'center',
                    render: r => {
                        return `${r.sdk_target}`
                    }
                },
                {
                    title: 'Количество разрешений',
                    key: 'permissions',
                    align: 'center',
                    render: r => {
                        return `${r.permissions.length}`
                    }
                } 
            );
        }

        columns.push(
            {
                title: '',
                key: 'actions',
                align: 'center',
                render: () => {
                    return (
                        <Button
                            icon={<DeleteFilled/>}
                            type={`danger`}
                            shape={`circle`}
                            onClick={() => {
                                setIsFinished(false);
                                setRelease([]);
                                setStartUploading(false);
                            }}
                        />
                    )
                }
            }
        );

    return (
        <>
            
            <h2>Загрузить - {app_type === 'linux' ? 'RPM-файл' : 'APK-файл'}</h2>  
            {startUploading === false && (
                <Upload.Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined/>
                    </p>
                    <p className="ant-upload-text">Кликните или перетащите файл на область для загрузки {app_type === 'linux' ? 'RPM-файл' : 'APK-файл'}</p>
                </Upload.Dragger>
            )}
            {startUploading === true && (
                <div className={`upload--progress`}>
                    <Progress type="circle" percent={progress} width={120}/>
                </div>
            )}
            {isFinished && (
                <div className="table__info">
                    <Table
                        columns={columns}
                        dataSource={release}
                        locale={{'emptyText': 'У вас пока нет релизов на публикацию'}}
                        rowKey={(item) => item.id}
                        pagination={{
                            hideOnSinglePage: true,
                        }}
                    />
                </div>
            )}
        </>
    );
}

export default ReleaseCreateController;